// is an harcoded array because the voices should not change and reduce the cost of the request
const bucket =
  process.env.REACT_APP_KEYS_ENV === 'production'
    ? 'promotionwingman-prod'
    : 'promotionwingman';

export const voices = [
  {
    'name': 'en-US-Wavenet-B',
    'ssmlGender': 'MALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Wavenet-B',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Wavenet-B.mp3`,
  },
  {
    'name': 'en-US-Casual-K',
    'ssmlGender': 'MALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Casual-K',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Casual-K.mp3`,
  },
  {
    'name': 'en-US-Neural2-A',
    'ssmlGender': 'MALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Neural2-A',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Neural2-A.mp3`,
  },
  {
    'name': 'en-US-Neural2-C',
    'ssmlGender': 'FEMALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Neural2-C',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Neural2-C.mp3`,
  },
  {
    'name': 'en-US-Neural2-D',
    'ssmlGender': 'MALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Neural2-D',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Neural2-D.mp3`,
  },
  {
    'name': 'en-US-Neural2-E',
    'ssmlGender': 'FEMALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Neural2-E',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Neural2-E.mp3`,
  },
  {
    'name': 'en-US-Neural2-F',
    'ssmlGender': 'FEMALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Neural2-F',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Neural2-F.mp3`,
  },
  {
    'name': 'en-US-Neural2-G',
    'ssmlGender': 'FEMALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Neural2-G',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Neural2-G.mp3`,
  },
  {
    'name': 'en-US-Neural2-H',
    'ssmlGender': 'FEMALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Neural2-H',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Neural2-H.mp3`,
  },
  {
    'name': 'en-US-Neural2-I',
    'ssmlGender': 'MALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Neural2-I',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Neural2-I.mp3`,
  },
  {
    'name': 'en-US-Neural2-J',
    'ssmlGender': 'MALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Neural2-J',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Neural2-J.mp3`,
  },
  {
    'name': 'en-US-News-K',
    'ssmlGender': 'FEMALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English News-K',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-News-K.mp3`,
  },
  {
    'name': 'en-US-News-L',
    'ssmlGender': 'FEMALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English News-L',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-News-L.mp3`,
  },
  {
    'name': 'en-US-News-N',
    'ssmlGender': 'MALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English News-N',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-News-N.mp3`,
  },
  {
    'name': 'en-US-Polyglot-1',
    'ssmlGender': 'MALE',
    'naturalSampleRateHertz': 24000,
    'languageCode': 'en-US',
    'decodeName': 'US English Polyglot-1',
    'example': `https://${bucket}.nyc3.cdn.digitaloceanspaces.com/audios/voices/en-US-Polyglot-1.mp3`,
  },
];
